import React, { useState, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { Filter, PlusCircle } from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../core/pagination/datatable";
import Axios from "axios";
import { useEffect } from "react";
import { setinventoryproducts_data } from "../../core/redux/action";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  API_BASE_URL,
  GET_INVENTORY_PRODUCTS,
  GET_USER_STORES,
  GET_VSTORE_PROD,
  GET_BARCODE_TYPE,
} from "../../Config";
import { getUserPermissions } from "../../UserPermissions";
import Select from "react-select";
import AddProductInventory from "../../core/modals/stocks/addproductinventoryModal";
import JsBarcode from "jsbarcode";
import QRCode from "qrcode";
import SpinLoader from "../loader/SpinLoader";
// import PrintBarcodeContent from './printbarcode';
// import PrintQRcodeContent from './printqrcode';

const ProductInventory = () => {
  const [userDataSession, setUserDataSession] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  const [permissions, setPermissions] = useState({
    isRead: "d-none",
    isWrite: "d-none",
    isDelete: "d-none",
    isExport: "d-none",
  });

  useEffect(() => {
    const perms = getUserPermissions("Categories");
    setPermissions(perms);
  }, []);

  const data = useSelector((state) => state.toggle_header);
  const dispatch = useDispatch();
  const dataSource = useSelector((state) => state.inventoryproducts_data) || [];
  const [searchQuery, setSearchQuery] = useState("");
  const [printBarcodeData, setPrintBarcodeData] = useState([]);
  // console.log(printBarcodeData)
  const [printQRcodeData, setPrintQRcodeData] = useState([]);
  const [printBarcodeDataUI, setPrintBarcodeDataUI] = useState([]);
  const [parsedHtmlPreview, setParsedHtmlPreview] = useState("");
  // console.log(printBarcodeDataUI)
  // const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      const api = `${API_BASE_URL}${GET_INVENTORY_PRODUCTS}?OrgId=${userDataSession.OrgId}&ProductId=0&StoreId=0`;
      Axios.get(api)
        .then((response) => {
          if (response.data.Status) {
            dispatch(setinventoryproducts_data(response.data.ResultData));
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [dispatch, userDataSession]);

  const [productsData, setProductsData] = useState([]);
  const [storesData, setStoresData] = useState([]);
  const [selectedStore, setSelectedStore] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(0);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && userDataSession.UserId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?UserId=${userDataSession.UserId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setStoresData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      Axios.get(
        `${API_BASE_URL}${GET_BARCODE_TYPE}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setPrintBarcodeDataUI(response.data.ResultData[0]);
            // console.log(printBarcodeDataUI, 'barcode ui getting from api');
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    // console.log(selectedStore);
    if (selectedStore && userDataSession.OrgId) {
      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: 0,
        ProductId: 0,
        StoreId: selectedStore.value,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 1,
      };

      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            setProductsData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [selectedStore, userDataSession]);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const columns = [
    {
      title: "Item",
      dataIndex: "ProductName",
      sorter: (a, b) => a.ProductName.localeCompare(b.ProductName),
    },
    // {
    //     title: 'Store',
    //     dataIndex: 'StoreName',
    //     sorter: (a, b) => a.StoreName.localeCompare(b.StoreName),
    // },
    {
      title: "Barcode",
      dataIndex: "BarCode",
      sorter: (a, b) => a.BarCode.localeCompare(b.BarCode),
    },

    {
      title: "Quantity",
      dataIndex: "Quantity",
      sorter: (a, b) => a.Quantity.localeCompare(b.Quantity),
    },
    {
      title: "Weight",
      dataIndex: "Weight",
      sorter: (a, b) => a.Weight.localeCompare(b.Weight),
    },
    {
      title: "MFG Date",
      dataIndex: "MfgDate",
      sorter: (a, b) => a.MfgDate.localeCompare(b.MfgDate),
      render: (text) => {
        const date = new Date(text);
        return date.toLocaleDateString("en-GB"); // This will format as dd-mm-yyyy
      },
    },
    {
      title: "EXP Date",
      dataIndex: "ExpiryDate",
      sorter: (a, b) => a.ExpiryDate.localeCompare(b.ExpiryDate),
      render: (text) => {
        const date = new Date(text);
        return date.toLocaleDateString("en-GB");
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <td>
            <div className="edit-delete-action">
              <Link to="#" className="dropdown-toggl" data-bs-toggle="dropdown">
                <i className="fa-solid fa-ellipsis-vertical btn border"></i>
              </Link>
              <div className="dropdown-menu dropdown-menu-right">
                {/* <Link
                        to="#"
                        className="dropdown-item my-3 ms-3"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasRightViewStockTrnsf"
                        aria-controls="offcanvasRightViewStockTrnsf"
                        onClick={() => showEditModal(record)}
                      >
                        <i className="fa-regular fa-eye me-2"></i>
                        View
                      </Link> */}
                <Link
                  to="#"
                  className="dropdown-item my-3 ms-3"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightViewBarcode"
                  aria-controls="offcanvasRightViewBarcode"
                  onClick={() => handlePreviewBarcode(record)}
                >
                  <i className="fa-solid fa-barcode me-2"></i>
                  Barcode
                </Link>
                <Link
                  to="#"
                  className="dropdown-item my-3 ms-3"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightViewQRcode"
                  aria-controls="offcanvasRightViewQRcode"
                  onClick={() => handleGenerateQRCode(record)}
                >
                  <i className="fa-solid fa-qrcode me-2"></i>
                  QR Code
                </Link>
              </div>
            </div>
          </td>
        );
      },
    },
  ];

  const handleStoreChange = (selectedOption) => {
    setSelectedStore(selectedOption);
  };

  const handleProductChange = (selectedOption) => {
    setSelectedProduct(selectedOption);
  };

  // region Search Btn Filter data
  const fetchFilterData = () => {
    if (
      (userDataSession && userDataSession.OrgId) ||
      selectedProduct ||
      selectedStore
    ) {
      let selectedProductvalue = 0;
      let selectedStorevalue = 0;
      if (selectedProduct) {
        selectedProductvalue = selectedProduct.value;
      }
      if (selectedStore) {
        selectedStorevalue = selectedStore.value;
      }

      const api = `${API_BASE_URL}${GET_INVENTORY_PRODUCTS}?OrgId=${userDataSession.OrgId}&ProductId=${selectedProductvalue}&StoreId=${selectedStorevalue}`;
      console.log(api);
      Axios.get(api)
        .then((response) => {
          console.log(response.data);
          if (response.data.Status) {
            dispatch(setinventoryproducts_data(response.data.ResultData));
            console.log(
              response.data.ResultData,
              "response.data.ResultDataresponse.data.ResultData"
            );
            setLoading(false);
          } else {
            dispatch(setinventoryproducts_data([]));
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          dispatch(setinventoryproducts_data([]));
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  };

  const filteredData = dataSource.filter(
    (item) =>
      (item &&
        item.ProductName &&
        item.ProductName.toLowerCase().includes(searchQuery.toLowerCase())) ||
      // (item.StoreName && item.StoreName.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.BarCode &&
        item.BarCode.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const handleDownloadExcel = () => {
    if (data.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = dataSource?.map((item) => ({
      "Product Name": item.ProductName,
      "Bar Code": item.BarCode,
      "Manifacture Date": item.MfgDate,
      "Expiry Date": item.ExpiryDate,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "InventoryProducts");

    // Save the workbook to a file
    XLSX.writeFile(wb, "InventoryProducts.xlsx");
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Attendance Report",
      author: "Your Name",
      creator: "Your Application",
    });

    const tableData = [];

    const headers = [
      "Name",
      "BarCode",
      "Quantity",
      "Manufacture Date",
      "Expiry Date",
    ];
    tableData.push(headers);

    dataSource.forEach((item) => {
      const row = [];
      row.push(
        item.ProductName,
        item.BarCode,
        item.Quantity,
        item.MfgDate,
        item.ExpiryDate
      );

      const formattedManufactureDate = formatDate(item.MfgDate);
      row.push(formattedManufactureDate);

      const formattedExpiryDate = formatDate(item.ExpiryDate);
      row.push(formattedExpiryDate);

      tableData.push(row);
    });

    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    doc.save("InventoryProducts.pdf");
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "2rem",
      height: "2.4rem",
    }),
  };

  const barcodeRef = useRef();
  const qrCodeRef = useRef();

  const handlePreviewBarcode = (item) => {
    console.log(item, "data assign at prievie btn click");
    setPrintBarcodeData(item);
    setTimeout(() => {
      generateBarcode(item);
    }, 0);
  };

  useEffect(() => {
    if (printBarcodeData) {
      generateBarcode(printBarcodeData);
    }
  }, [printBarcodeData]);
  console.log(printBarcodeData);

  const generateBarcode = (item) => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, item.BarCode, {
        format: "CODE128",
        lineColor: "#000",
        width: 2,
        height: 40,
        displayValue: true,
      });
    } else {
      console.error("barcodeRef.current is undefined");
    }
  };

  const handlePrintBarcode = (item) => {
    setPrintBarcodeData(item);
    generateBarcode(item);

    setTimeout(() => {
      const barcodeElement = barcodeRef.current;

      if (barcodeElement && barcodeElement.outerHTML.includes("<svg")) {
        const barcodeSVG = barcodeRef.current.outerHTML.replace(
          "<svg",
          '<svg width="450px" height="100px"'
        );

        console.log(printBarcodeDataUI.HtmlString);
        console.log(item);
        const printContent = printBarcodeDataUI?.HtmlString.replaceAll(
          "#ORGNAME#",
          item.StoreName || ""
        )
          .replaceAll("#ITEMNAME#", item.ProductName || "")
          .replaceAll("#WEIGHT#", item.Weight || "")
          .replaceAll("#UNITS#", item.Units || "")
          .replaceAll("#MFGDATE#", formatDate(item.MfgDate) || "")
          .replaceAll("#EXPIRYDATE#", formatDate(item.ExpiryDate) || "")
          .replaceAll("#ITEMPRICE#", item.MRP || "")
          .replaceAll("#PHNO#", item.PhoneNumber || "")
          .replaceAll("#BARCODEIMG#", barcodeSVG);

        console.log(printContent,'barcode inventory');
        const printWindow = window.open("", "_blank");
        printWindow.document.write(printContent);
        printWindow.document.close();

        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        }, 500);
      } else {
        console.error("Barcode not rendered correctly.");
      }
    }, 300);
  };

  console.log(printBarcodeData);
  // const buildParsedHtml = (template, printBarcodeData, barcodeSVG) => {
  //   console.log(printBarcodeData)
  //   if (!template || !printBarcodeData) return "";
  //   return template
  //     .replaceAll("#ORGNAME#", printBarcodeData.StoreName || "")
  //     .replaceAll("#ITEMNAME#", printBarcodeData.ProductName || "")
  //     .replaceAll("#WEIGHT#", printBarcodeData.Weight || "")
  //     .replaceAll("#UNITS#", printBarcodeData.Units || "")
  //     .replaceAll("#MFGDATE#", formatDate(printBarcodeData.MfgDate) || "")
  //     .replaceAll("#EXPIRYDATE#", formatDate(printBarcodeData.ExpiryDate) || "")
  //     .replaceAll("#ITEMPRICE#", printBarcodeData.MRP || "")
  //     .replaceAll("#PHNO#", printBarcodeData?.PhoneNumber || "")
  //     .replaceAll("#BARCODEIMG#", barcodeSVG || "");
  // };
  //  useEffect(() => {
  //     if (printBarcodeData && barcodeRef.current && printBarcodeDataUI?.HtmlString) {
  //       generateBarcode(printBarcodeData);
  //       const barcodeSVG = barcodeRef.current.outerHTML.replace(
  //         "<svg",
  //         '<svg width="450px" height="100px"'
  //       );
  //       const parsedHtml = buildParsedHtml(printBarcodeDataUI.HtmlString, printBarcodeData, barcodeSVG);
  //       setParsedHtmlPreview(parsedHtml);
  //     }
  //   }, [printBarcodeData, printBarcodeDataUI]);

  useEffect(() => {
    if (
      printBarcodeData &&
      printBarcodeDataUI?.HtmlString &&
      barcodeRef.current
    ) {
      const barcodeSVG = barcodeRef.current.outerHTML;
      const overrideStyle = `
    <style>
      #print-section {
        min-height: 0 !important;
        padding-top: 3px !important;
      }
    </style>
  `;

      const parsedHtml = printBarcodeDataUI.HtmlString.replaceAll(
        "#ORGNAME#",
        printBarcodeData.StoreName || ""
      )
        .replaceAll("#ITEMNAME#", printBarcodeData.ProductName || "")
        .replaceAll("#WEIGHT#", printBarcodeData.Weight || "")
        .replaceAll("#UNITS#", printBarcodeData.Units || "")
        .replaceAll("#MFGDATE#", formatDate(printBarcodeData.MfgDate) || "")
        .replaceAll(
          "#EXPIRYDATE#",
          formatDate(printBarcodeData.ExpiryDate) || ""
        )
        .replaceAll("#ITEMPRICE#", printBarcodeData.MRP || "")
        .replaceAll("#PHNO#", printBarcodeData?.PhoneNumber || "")
        .replaceAll("#BARCODEIMG#", barcodeSVG || "");

      setParsedHtmlPreview(overrideStyle + parsedHtml);
      // console.log(parsedHtmlPreview);
    }
  }, [printBarcodeData, printBarcodeDataUI, barcodeRef.current]);

  const handleGenerateQRCode = async (item) => {
    console.log(item);
    setPrintQRcodeData(item);
    try {
      const url = await QRCode.toDataURL(item.BarCode || "Default Text");
      qrCodeRef.current = url;
    } catch (error) {
      console.error("Error generating QR code:", error);
    }
  };
  const handlePrintQRcode = (item) => {
    setPrintQRcodeData(item); // Ensure QR code component renders with this data

    setTimeout(() => {
      const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        return isNaN(date) ? "" : date.toLocaleDateString("en-GB");
      };

      const qrNode = qrCodeRef.current;

      let qrHTML = "";
      if (qrNode?.tagName === "CANVAS") {
        try {
          const dataUrl = qrNode.toDataURL("image/png");
          qrHTML = `<img src="${dataUrl}" width="100" height="100" alt="QR Code" />`;
        } catch (err) {
          console.error("Error generating QR image from canvas:", err);
        }
      } else {
        console.error("QR code not rendered yet or not canvas.");
        return;
      }

      let printContent = printBarcodeDataUI?.QRCodestring;
      if (typeof printContent !== "string") {
        printContent = `
        <html>
          <head>
            <title>Print</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
                text-align: center;
              }
              .label {
                font-size: 16px;
                font-weight: bold;
                margin: 5px 0;
              }
              .info {
                font-size: 14px;
                margin: 4px 0;
              }
              .price {
                font-size: 20px;
                margin: 10px 0;
              }
              .qr {
                margin-top: 10px;
              }
              img {
                border: 1px solid #000;
              }
            </style>
          </head>
          <body>
            <div class="label">$StoreName</div>
            <div class="label">$ProductName</div>
            <div class="info">Weight: $Weight</div>
            <div class="info">Mfg: $MfgDate | Exp: $ExpiryDate</div>
            <div class="price">MRP: ₹$MRP</div>
            <div class="qr">$qrCode</div>
          </body>
        </html>
      `;
      }

      printContent = printContent
        .replaceAll("$StoreName", item?.StoreName || "")
        .replaceAll("$ProductName", item?.ProductName || "")
        .replaceAll("$Weight", item?.Weight || "")
        .replaceAll("$MfgDate", formatDate(item?.MfgDate))
        .replaceAll("$ExpiryDate", formatDate(item?.ExpiryDate))
        .replaceAll("$MRP", item?.MRP || "")
        .replaceAll("$qrCode", qrHTML);

      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.onload = () => {
          const qrImg = printWindow.document.querySelector("img");
          if (qrImg && !qrImg.complete) {
            qrImg.onload = () => {
              printWindow.focus();
              printWindow.print();
              printWindow.close();
            };
          } else {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          }
        };
      } else {
        console.error("Failed to open print window.");
      }
    }, 300); // delay so QR canvas renders first
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Product Inventory</h4>
                <h6>Manage your product inventory</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li className={` ${permissions.isExport}`} onClick={generatePDF}>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li
                className={` ${permissions.isExport}`}
                onClick={handleDownloadExcel}
              >
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className={`page-btn ${permissions.isRead}`}>
              <Link
                to="#"
                className="btn btn-added"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightAddProdInventory"
                aria-controls="offcanvasRightAddProdInventory"
              >
                <PlusCircle />
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="input-group search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <span className="input-group-text bg-white">
                      <i data-feather="search" className="feather-search"></i>
                    </span>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                  >
                    <Filter
                      className="filter-icon"
                      onClick={toggleFilterVisibility}
                    />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
              </div>
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row mb-2">
                    <div className="col-lg-3 col-sm-6 col-12">
                      <label>Store</label>
                      <Select
                        className="select"
                        onChange={handleStoreChange}
                        options={[
                          { value: 0, label: "All" },
                          ...storesData.map((store) => ({
                            value: store.StoreId,
                            label: store.Name,
                          })),
                        ]}
                        styles={customStyles}
                        placeholder="Choose store"
                      />
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <label>Product</label>
                      <Select
                        className="select"
                        id="storeSelect"
                        onChange={handleProductChange}
                        options={[
                          { value: 0, label: "All" },
                          ...productsData.map((prod) => ({
                            value: prod.Id,
                            label: prod.ProductName,
                          })),
                        ]}
                        placeholder="Choose product"
                        styles={customStyles}
                      />
                      {/* <Select
                                                className="select"
                                                id="storeSelect"
                                                onChange={handleProductChange}
                                                options={productsData.map((prod) => ({
                                                    value: prod.Id,
                                                    label: prod.ProductName,
                                                }))}
                                                placeholder="Choose product"
                                                styles={customStyles}
                                            /> */}
                    </div>
                    <div className="col-lg-3 col-sm-6 col-6 mt-0 mt-md-3">
                      <div className="input-blocks">
                        <button
                          className="btn btn-filters "
                          onClick={fetchFilterData}
                        >
                          <i data-feather="search" className="feather-search" />
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                {loading ? (
                  <SpinLoader/>
                  // <div className="loader m-auto"></div>
                ) : (
                  <Table columns={columns} dataSource={filteredData} />
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>

      {/* Barcode Preview */}
      {/* <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewBarcode"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "40%", maxWidth: "40%" }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel" className="mb-0">
            Barcode Preview
          </h4>
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>
        <hr />
        <div className="offcanvas-body">
          <div className="row">
            <div className="m-auto text-center col-6">
              <h5 className="text-uppercase">{printBarcodeData?.StoreName}</h5>
              <h5 className="text-uppercase">
                {printBarcodeData?.ProductName}
              </h5>
              <div className="col-12 m-auto">
                <table className="table table-border">
                  <tbody>
                    <tr style={{ lineHeight: "0.5", padding: "0" }}>
                      <td className="text-start fw-semibold p-0 ">
                        Net.Weight:
                      </td>
                      <th className="text-end fw-bold p-0 ">
                        {printBarcodeData?.Weight}
                      </th>
                    </tr>
                    <tr style={{ lineHeight: "0.5", padding: "0" }}>
                      <td className="text-start fw-semibold p-0 ">
                        Packaged On:
                      </td>
                      <th className="text-end fw-bold p-0 ">
                        {new Date(printBarcodeData?.MfgDate).toLocaleDateString(
                          "en-GB"
                        )}
                      </th>
                    </tr>
                    <tr style={{ lineHeight: "0.5", padding: "0" }}>
                      <td className="text-start fw-semibold p-0 ">
                        Best Before:
                      </td>
                      <th className="text-end fw-bold p-0 ">
                        {new Date(
                          printBarcodeData?.ExpiryDate
                        ).toLocaleDateString("en-GB")}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h5 className="">MRP - {printBarcodeData?.MRP}/-</h5>
              <svg
                ref={barcodeRef}
                className="col-12"
                style={{ marginTop: "-14px" }}
              />
            </div>
            <div className="modal-footer-btn">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-success"
                onClick={() => handlePrintBarcode(printBarcodeData)}
              >
                Print
              </button>
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewBarcode"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "40%", maxWidth: "40%" }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel" className="mb-0">
            Barcode Preview
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          {!printBarcodeData ? (
            <div className="text-center">No barcode data available</div>
          ) : parsedHtmlPreview && parsedHtmlPreview.trim() !== "" ? (
            <div className="row">
              <div className="m-auto col-12 text-center ">
                {/* Hidden barcode used to extract SVG once */}
                <div className="d-none d-block">
                  <svg ref={barcodeRef} />
                </div>
                {/* Final parsed HTML preview */}
                <div
                  className="p-2"
                  dangerouslySetInnerHTML={{ __html: parsedHtmlPreview }}
                />
              </div>
              <div className="modal-footer-btn">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-success"
                  onClick={() => handlePrintBarcode(printBarcodeData)}
                >
                  Print
                </button>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="m-auto text-center col-6">
                <h5 className="text-uppercase">
                  {printBarcodeData?.StoreName}
                </h5>
                <h5 className="text-uppercase">
                  {printBarcodeData?.ProductName}
                </h5>
                <div className="col-12 m-auto">
                  <table className="table table-border">
                    <tbody>
                      <tr style={{ lineHeight: "0.5", padding: "0" }}>
                        <td className="text-start fw-semibold p-0">
                          Net.Weight:
                        </td>
                        <th className="text-end fw-bold p-0">
                          {printBarcodeData?.Weight}
                        </th>
                      </tr>
                      <tr style={{ lineHeight: "0.5", padding: "0" }}>
                        <td className="text-start fw-semibold p-0">
                          Packaged On:
                        </td>
                        <th className="text-end fw-bold p-0">
                          {new Date(
                            printBarcodeData?.MfgDate
                          ).toLocaleDateString("en-GB")}
                        </th>
                      </tr>
                      <tr style={{ lineHeight: "0.5", padding: "0" }}>
                        <td className="text-start fw-semibold p-0">
                          Best Before:
                        </td>
                        <th className="text-end fw-bold p-0">
                          {new Date(
                            printBarcodeData?.ExpiryDate
                          ).toLocaleDateString("en-GB")}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h5 className="">MRP - {printBarcodeData?.MRP}/-</h5>
                <svg
                  ref={barcodeRef}
                  className="col-12"
                  style={{ marginTop: "-14px" }}
                />
              </div>
              <div className="modal-footer-btn">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-success"
                  onClick={() => handlePrintBarcode(printBarcodeData)}
                >
                  Print
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* QRcode Preview */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewQRcode"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "40%", maxWidth: "40%" }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel" className="mb-0">
            QRcode Preview
          </h4>
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>
        <hr />
        <div className="offcanvas-body">
          <div className="row">
            <h5 className="text-uppercase text-center">
              {printQRcodeData?.StoreName}
            </h5>
            <h5 className="text-uppercase text-center">
              {printQRcodeData?.ProductName}
            </h5>
            <div className="justify-content-center d-flex">
              <div className="col-md-4 text-start">
                <table className="table table-borderless">
                  <tbody>
                    <tr style={{ lineHeight: "0.5" }}>
                      <td className="text-start fw-semibold p-0">
                        Net Weight:
                      </td>
                      <th className="text-end fw-bold p-0">
                        {printQRcodeData?.Weight}
                      </th>
                    </tr>
                    <tr style={{ lineHeight: "0.5" }}>
                      <td className="text-start fw-semibold p-0">
                        Packaged On:
                      </td>
                      <th className="text-end fw-bold p-0">
                        {new Date(printQRcodeData?.MfgDate).toLocaleDateString(
                          "en-GB"
                        )}
                      </th>
                    </tr>
                    <tr style={{ lineHeight: "0.5" }}>
                      <td className="text-start fw-semibold p-0">
                        Best Before:
                      </td>
                      <th className="text-end fw-bold p-0">
                        {new Date(
                          printQRcodeData?.ExpiryDate
                        ).toLocaleDateString("en-GB")}
                      </th>
                    </tr>
                  </tbody>
                </table>
                <h5 className="mt-2">MRP - {printQRcodeData?.MRP}/-</h5>
              </div>

              <div className="col-md-3 text-center d-flex flex-column align-items-center justify-content-center">
                <img
                  src={qrCodeRef.current}
                  alt="Generated QR Code"
                  style={{ width: "100px", height: "100px" }}
                />
                <h6>{printQRcodeData?.BarCode}</h6>
              </div>
            </div>
          </div>

          <div className="modal-footer-btn mt-3 text-end">
            <button
              type="button"
              className="btn btn-cancel me-2"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-success"
              onClick={() => handlePrintQRcode(printQRcodeData)}
            >
              Print
            </button>
          </div>
        </div>
      </div>

      <AddProductInventory />
    </div>
  );
};

export default ProductInventory;
